// Copyright 2022 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

export let serverUrl = `https://api.enkiro.io`
export let cloudflare_client_id = "2085167f4cfc594379d70e2b21e31bf1.access"
export let cloudflare_client_secret = "ca668397c569ef09349078f9714a1c92057dab4e83f040bfa3904b74aea8c758"
